import {
  Controller,
  ControllerProps,
  ControllerRenderProps,
  FieldErrors,
  Path,
  useFormContext,
} from "react-hook-form";
import { Box, HStack, Input, Stack, Text } from "@chakra-ui/react";
import { TicketTypeValues } from "./schema";

function InputWithLabel<T = TicketTypeValues>({
  name,
  label,
  placeholder,
  children = <></>,
  required,
  labelAddon,
  renderInput,
  //@ts-ignore
  controllerProps = {},
  //@ts-ignore
  inputProps = {},
  disabled = false,
  ...props
}: {
  name: Path<T>;
  label: string;
  required?: boolean;
  labelAddon?: React.ReactNode;
  renderInput?: (props: {
    field: ControllerRenderProps<T>;
    errors: FieldErrors<T>;
  }) => React.ReactElement;
  placeholder?: string;
  children?: React.ReactNode;
  controllerProps?: Partial<ControllerProps<T>>;
  inputProps?: Partial<any>;
  disabled?: boolean;
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext<T>();

  const _renderInput = renderInput
    ? renderInput
    : ({
        field,
        errors,
      }: {
        field: ControllerRenderProps<T>;
        errors: FieldErrors<T>;
      }) => {
        return (
          <Input
            bg="white"
            border="1px solid #E8E8E8"
            borderRadius="8px"
            boxShadow="0px 2px 6px rgba(0,0,0,0.035)"
            height="48px"
            placeholder={placeholder}
            isInvalid={!!errors[name as string]}
            //@ts-ignore
            value={field.value}
            {...field}
            {...inputProps}
            disabled={field.disabled}
          />
        );
      };

  return (
    <Stack spacing={0} w="full" {...props}>
      <HStack
        w="full"
        justifyContent="space-between"
        alignItems="center"
        mb="6px"
      >
        <Text fontWeight={"semibold"} lineHeight="22px">
          {label}
          {required ? " (*)" : ""}
        </Text>
        {labelAddon ? <Box>{labelAddon}</Box> : null}
      </HStack>
      <Controller<T>
        name={name}
        control={control}
        defaultValue={undefined}
        render={({ field }) => _renderInput({ field, errors })}
        {...controllerProps}
      />
      {children}
      <Box h={4}>
        {errors[name as string] ? (
          <Text fontSize={"sm"} color="red.300">
            {`${errors[name].message}`}
          </Text>
        ) : null}
      </Box>
    </Stack>
  );
}

export default InputWithLabel;
